import { FC } from 'react';

import Checkbox from '@components/Checkbox';
import Skeleton from '@components/skeletons/Skeleton';

import {
  SingleSelectionFilterWrapper,
  SingleSelectionCheckboxContainer,
} from './SingleSelectionFilterStyle';

export interface SingleSelectionFilterProps {
  title: string;
  subTitle?: React.ReactNode;
  handleCheckBoxChange: (e: boolean) => void;
  checked: boolean;
  className?: string;
  name?: string;
  mode?: 'controlled' | 'uncontrolled';
  isLoading?: boolean;
}

const SingleSelectionFilter: FC<SingleSelectionFilterProps> = ({
  title,
  subTitle,
  handleCheckBoxChange,
  checked,
  className,
  name,
  mode = 'uncontrolled',
  isLoading = false,
}) => {
  return (
    <SingleSelectionFilterWrapper>
      <SingleSelectionCheckboxContainer className={className}>
        {isLoading ? (
          <Skeleton width={130} height={20} marginBottom={10} />
        ) : (
          <Checkbox
            title={title}
            subTitle={subTitle}
            className='filters-checkbox'
            onChange={handleCheckBoxChange}
            value={checked}
            checked={checked}
            name={name}
            mode={mode}
          />
        )}
      </SingleSelectionCheckboxContainer>
    </SingleSelectionFilterWrapper>
  );
};

export default SingleSelectionFilter;
